import { Injectable } from '@angular/core';

import { RestService } from "../../../core/services/rest.service";
import {Frota, FrotaImagem} from "./frota.model";
import {apiName, frotaImagemApiName} from "./data.service";

@Injectable()
export class FrotaApiService {
    private includeFilter: any = [{"modelo":["tipoBem","marca"]},{"motoristaPrincipal":[{"funcionario":"pessoa"}]},"orgao","area","divisao","setor","localidade","cor","situacao","formaControle","odometroHorimetro","gpsModelo", "categoriaExigida"];

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Frota, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Frota, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"identificacao","include":this.includeFilter};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":this.includeFilter};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetByCategoria(categoriaId: number, done: any) {
        this._restService.onGet(apiName + '/categoria/' + categoriaId, done);
    }

    onGetByCategoriaQuery(categoriaId: number,filter: any, done: any) {
        filter.order = "identificacao";
        filter.include = this.includeFilter;
        this._restService.onGetPostCustom(apiName + '/categoria/' + categoriaId, filter, done);
    }

    onGetAllRastreamento(categoriaId: number, filter: any, done: any) {
        filter.order = "identificacao";
        filter.include = this.includeFilter;
        this._restService.onGetPostCustom(apiName + '/categoria/imagens/' + categoriaId, filter, done);
    }

    onGetApiUrl() {
        return apiName;
    }

    //bem imagem
    onPostImagem(object: FrotaImagem, done: any) {
        this._restService.onPost(frotaImagemApiName, object, done);
    }

    onPostImages(object: FrotaImagem, done: any) {
        this._restService.onPostCustom(frotaImagemApiName + '/bulk', object, done);
    }

    onDeleteImagem(objectId: number, done: any) {
        this._restService.onDelete(frotaImagemApiName, objectId, done);
    }

    onGetAllImagem(bemId: number, done: any) {
        let filter: any = {"order":"data","where":{"bemId": bemId,"ativo":true}};
        this._restService.onGetPost(frotaImagemApiName, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/frotas/shared/frota-api.service.ts
 **/